<template>
  <div class="flex flex-col justify-center items-start bg-pale-mint-grey gap-8 py-4">
    <div class="flex flex-col gap-4 items-center bg-white rounded-xl p-4">
      <div class="flex flex-row gap-2 items-center">
        <img :src="sessionsImage" alt="alt" class="w-20 h-20" />

        <div>
          <h3 class="text-midnight text-p1 font-bold mb-0">
            {{ $t('pages.platinum.features.exploreSessions.title') }}
          </h3>
          <p class="mb-0">
            {{ $t('pages.platinum.features.exploreSessions.description') }}
          </p>
        </div>
      </div>

      <!-- /live/events only 301s to /app/masterclasses now, so link the destination directly. Relative on
           purpose so the link stays on whichever host rendered this page (www-dev included). -->
      <a href="/app/masterclasses" class="bg-midnight text-white rounded py-2 px-4 font-medium">
        {{ $t('pages.platinum.features.exploreSessions.link') }}
      </a>
    </div>

    <div class="flex flex-col gap-4 items-center bg-white rounded-xl p-4">
      <div class="flex flex-row gap-2 items-center">
        <img :src="infographicsImage" alt="alt" class="w-20 h-20" />

        <div>
          <h3 class="text-midnight text-p1 font-bold mb-0">
            {{ $t('pages.platinum.features.browseInfographics.title') }}
          </h3>
          <p>
            {{ $t('pages.platinum.features.browseInfographics.description') }}
          </p>
        </div>
      </div>

      <!-- /infographics is the public marketing page (returns 200 with no auth gate), so a subscriber who
           has just paid lands on a signed-out page. /app/infographics is the in-app one and redirects
           through login with last_page_before_login, same as /app/masterclasses above. -->
      <a href="/app/infographics" class="bg-midnight text-white rounded py-2 px-4 font-medium">
        {{ $t('pages.platinum.features.browseInfographics.link') }}
      </a>
    </div>

    <a href="/app/for-you" class="text-mid-grey underline self-stretch text-center">
      {{ $t('pages.platinum.features.continueInBrowser') }}
    </a>
  </div>
</template>

<script>
  import sessionsImage from "./images/sessions.png"
  import infographicsImage from "./images/infographics.png"

  export default {
    name: "PlatinumFeatures",
    data: () => ({
      sessionsImage,
      infographicsImage
    })
  }
</script>
